import { APIReportFilters, Operator } from '@ardoq/api-types';
import {
  maybeGetDrilldownMappedValue,
  maybeGetPieOrBarChartDataId,
} from './utils';
import { isNull } from 'lodash';
import { CategoricalDrilldownData } from './renderTypes';
import { WidgetLinkedDashboardFilter } from './types';
import { widgetOperations } from './operations';

type GetWidgetDrilldownFiltersParams = {
  widgetRenderData: Array<{ label: string; value: number; id?: string }>;
  widgetDrilldownData: CategoricalDrilldownData;
  otherDataSegments: Array<{ name: string }>;
  dataName: string;
  isOtherSegment?: boolean;
  activeLinkedDashboardFilters?: WidgetLinkedDashboardFilter[];
};
export const getWidgetDrilldownFilters = ({
  widgetRenderData,
  widgetDrilldownData,
  otherDataSegments,
  dataName,
  isOtherSegment,
  activeLinkedDashboardFilters,
}: GetWidgetDrilldownFiltersParams): APIReportFilters => {
  const filterData = isOtherSegment
    ? otherDataSegments.map(({ name }) => name)
    : [dataName];

  // this performs a "merge" of widget-level filtering and dashboard filtering with specific drilldown filter that was clicked
  // if filter with same key was applied to a report, drilldown will override it with clicked value
  return {
    ...widgetOperations.mergeDashboardAndWidgetFilters(
      widgetDrilldownData.filters ?? {},
      activeLinkedDashboardFilters ?? []
    ),
    [widgetDrilldownData.fields[0]]: {
      values: filterData.map(name => {
        const value = maybeGetPieOrBarChartDataId(name, widgetRenderData);

        const mappedValue = maybeGetDrilldownMappedValue(
          value,
          widgetDrilldownData.drilldownMappings
        );

        return {
          label: name,
          value: mappedValue,
          operator: isNull(mappedValue) ? Operator.IS_EMPTY : Operator.EQUAL,
        };
      }),
    },
  };
};
